import {
    type GetPositionsResponseType
} from "./type";
import {
    request
} from "../request";

const getPositions = async (): Promise<GetPositionsResponseType> => {
    return await request<GetPositionsResponseType>("/staticData/getPositions", {
        method: "GET"
    });
};
export default getPositions;
